import React from "react";
import MobileSelectSheet from "@/components/mobile/MobileSelectSheet";

function getSelectTitle(select) {
  const labelledBy = select.getAttribute("aria-labelledby");
  if (labelledBy) {
    const label = document.getElementById(labelledBy)?.textContent?.trim();
    if (label) return label;
  }
  if (select.id) {
    const label = document.querySelector(`label[for="${CSS.escape(select.id)}"]`)?.textContent?.trim();
    if (label) return label;
  }
  return select.getAttribute("aria-label") || select.getAttribute("name")?.replace(/[-_]/g, " ") || "Select an option";
}

function readOptions(select) {
  return Array.from(select.options || [])
    .filter((option) => !option.disabled)
    .map((option) => ({ value: option.value, label: option.textContent?.trim() || option.value }));
}

export default function NativeSelectMobileSheet() {
  const [target, setTarget] = React.useState(null);
  const [items, setItems] = React.useState([]);
  const [value, setValue] = React.useState("");
  const [title, setTitle] = React.useState("Select an option");
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    const openSheet = (event) => {
      if (!window.matchMedia("(max-width: 767px)").matches) return;
      const select = event.target?.closest?.("select");
      if (!select || select.disabled || select.dataset.mobileSelectSheet === "off") return;
      event.preventDefault();
      event.stopPropagation();
      setTarget(select);
      setItems(readOptions(select));
      setValue(select.value);
      setTitle(getSelectTitle(select));
      setOpen(true);
      select.blur();
    };

    const handleKeyDown = (event) => {
      if ((event.key === "Enter" || event.key === " ") && event.target?.matches?.("select")) openSheet(event);
    };

    document.addEventListener("pointerdown", openSheet, true);
    document.addEventListener("keydown", handleKeyDown, true);
    return () => {
      document.removeEventListener("pointerdown", openSheet, true);
      document.removeEventListener("keydown", handleKeyDown, true);
    };
  }, []);

  const handleSelect = (nextValue) => {
    if (!target) return;
    target.value = nextValue;
    setValue(nextValue);
    target.dispatchEvent(new Event("input", { bubbles: true }));
    target.dispatchEvent(new Event("change", { bubbles: true }));
  };

  return (
    <MobileSelectSheet
      open={open}
      onOpenChange={setOpen}
      title={title}
      value={value}
      items={items}
      onSelect={handleSelect}
      description="Choose one option."
    />
  );
}